module.exports = __webpack_public_path__ + "img/analytics-chart-placeholder.f389eaf3.webp";